import { TwilsockOptions, TwilsockClient, TwilsockSdkClient } from "~/modules/websocket/TwilsockClient/TwilsockClient";

export function getTwilsockClient(token: string, productId: string, options?: TwilsockOptions): TwilsockClient {
    return new TwilsockSdkClient(token, productId, options);
}
